var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_7915)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_122_7915)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_122_7915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.46742 5.46492L5.56264 5.89716L6.2945 5.54917H6.31295V8.5868H7.15698V4.76147H6.4316L5.41357 5.22313L5.41457 5.22662H5.41357L5.46742 5.46492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6649 1.55536H2.57053C2.27091 1.55536 2.03809 1.80862 2.03809 2.10775V11.2042C2.27539 10.761 2.6513 10.4045 3.10696 10.1916V2.62424H16.1005V10.5665C16.5776 10.9943 16.8782 11.6155 16.8782 12.305C16.8782 12.3264 16.8762 12.3478 16.8762 12.3693C17.0772 12.2855 17.2257 12.0906 17.2257 11.8647V2.10775C17.2257 1.80912 16.9635 1.55536 16.6649 1.55536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22559 11.3442C6.3587 11.6374 6.43348 11.9619 6.43348 12.3064C6.43348 12.3413 6.43248 12.3782 6.43099 12.4141H6.98587C6.98437 12.3782 6.98287 12.3413 6.98287 12.3064C6.98287 11.9634 7.05815 11.6374 7.19127 11.3442H6.22559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4478 11.3442C11.5809 11.6374 11.6556 11.9619 11.6556 12.3064C11.6556 12.3413 11.6542 12.3782 11.6532 12.4141H12.208C12.2065 12.3782 12.2055 12.3413 12.2055 12.3064C12.2055 11.9634 12.2803 11.6374 12.4129 11.3442H11.4478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90047 5.43701V6.73073H7.66309V7.29359H8.90047V8.58681H9.51916V7.29359H10.7565V6.73073H9.51916V5.43701H8.90047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2459 7.58771L10.7578 8.03839V8.58679H13.4579V7.85543H11.9947V7.83L12.3616 7.53486C12.9175 7.03831 13.3966 6.51185 13.3966 5.86773C13.3966 5.16877 12.9175 4.64929 12.0485 4.64929C12.048 4.64929 12.0475 4.64929 12.047 4.64929H12.046C11.5246 4.64929 11.0754 4.83774 10.7862 5.0566L11.0415 5.7077C11.0425 5.7077 11.0425 5.71069 11.0435 5.71019V5.71269C11.2449 5.55764 11.534 5.39412 11.8661 5.39362C12.3083 5.39412 12.4987 5.64239 12.4987 5.95548C12.4858 6.40516 12.0859 6.8374 11.2459 7.58771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09726 13.827C4.93814 13.827 5.61981 13.1454 5.61981 12.3045C5.61981 11.4636 4.93814 10.7819 4.09726 10.7819C3.25638 10.7819 2.57471 11.4636 2.57471 12.3045C2.57471 13.1454 3.25638 13.827 4.09726 13.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31992 13.827C10.1608 13.827 10.8425 13.1454 10.8425 12.3045C10.8425 11.4636 10.1608 10.7819 9.31992 10.7819C8.47903 10.7819 7.79736 11.4636 7.79736 12.3045C7.79736 13.1454 8.47903 13.827 9.31992 13.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1293 14.4362H15.4837H13.5997H12.9541C12.465 14.4362 12.0492 14.7702 11.9261 15.2199C11.9261 15.2209 11.9261 15.2214 11.9261 15.2214C11.8418 14.9178 11.6284 14.665 11.3453 14.5354C11.2112 14.4746 11.0646 14.4362 10.9075 14.4362H10.2624H8.37793H7.73231C7.24374 14.4362 6.82297 14.7697 6.69933 15.2199C6.69933 15.2199 6.69933 15.2209 6.69933 15.2214C6.61508 14.9168 6.40419 14.665 6.12102 14.5354C5.98641 14.4741 5.84283 14.4362 5.68529 14.4362H5.03968H3.15568H2.51056C1.92328 14.4362 1.47559 14.9188 1.47559 15.5051V17.1947H5.85679H6.65097H6.74819H11.0795H11.8822H11.9704H17.1702V15.5041C17.1698 14.9188 16.7156 14.4362 16.1293 14.4362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5421 13.827C15.383 13.827 16.0646 13.1454 16.0646 12.3045C16.0646 11.4636 15.383 10.7819 14.5421 10.7819C13.7012 10.7819 13.0195 11.4636 13.0195 12.3045C13.0195 13.1454 13.7012 13.827 14.5421 13.827Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_7915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_122_7915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(-0.0244141)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_122_7915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 15.75,
    fill: "white",
    transform: "translate(1.47559 1.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.acb28a69c40f3eef5ce806da5c9b5980.svg";
export { ForwardRef as ReactComponent };